/* globals Forms, Geocomplete */

const initGeocompleteFields = () => {
  const initSelect = (element) => {
    Geocomplete.initSelect({
      input: element.find('#gmaps-input-address'),
      details: element.find('.details')
    })
  }

  $('#addresses .nested-fields').each(function () {
    initSelect($(this))
  })

  $('#addresses').on('cocoon:after-insert', function (e, element) {
    initSelect(element)
    Forms.initSelect2()
  })
}

window['job_postings#new'] = () => {
  initGeocompleteFields()

  const miniJobOfferTypes = ['job', 'artist']
  const miniJob = document.getElementById('job_posting_mini_job')
  const socialInsurance = document.getElementById('job_posting_social_insurance')
  const jobOfferType = document.getElementById('job_posting_job_offer_type')
  const socialInsuranceDependentVisibility = document.querySelectorAll('.social-insurance-dependent')

  socialInsurance.addEventListener('change', (e) => {
    if (e.currentTarget.checked) {
      miniJob.disabled = true
      socialInsuranceDependentVisibility.forEach(node => {
        node.childNodes.forEach(child => (child.disabled = false))
        node.classList.remove('invisible')
      })
    } else if (miniJobOfferTypes.includes(jobOfferType.value)) {
      miniJob.disabled = false
    } else {
      socialInsuranceDependentVisibility.forEach(node => {
        node.childNodes.forEach(child => (child.disabled = true))
        node.classList.add('invisible')
      })
    }
  })

  jobOfferType.addEventListener('change', (e) => {
    $('#s2id_job_posting_job_codes').select2('val', '').trigger('change')
    const selected = e.currentTarget.value

    if (miniJobOfferTypes.includes(selected) && socialInsurance.checked === 0) {
      miniJob.disabled = false
    } else {
      miniJob.disabled = true
    }

    // super_vision_desired logic
    const superVisionDesired = document.getElementById('job_posting_super_vision_desired')
    if (['job', 'apprenticeship', 'internship_training'].includes(selected)) {
      superVisionDesired.disabled = false
    } else {
      superVisionDesired.disabled = true
    }
  })
}

window['job_postings#edit'] = window['job_postings#new']
